<template>
  <div class="service-container">
    <div class="content">
      <div class="title">我们为您提供以下服务</div>
      <div class="en-title">Services Support</div>
    </div>
    <div class="our-service">
        <div class="box" :style="key==0?bot_min_fast:key==1?bot_min_normal:bot_min_low" v-for="(item,key) in serviceItem" :key="key"
        @click="$router.push('/service')">
          <div class="service-logo">
            <img :src="$img + item.coverImg">
          </div>
          <div class="service-text">{{item.title}}</div>
        </div>
    </div>
    <div class="more-product-btn" @click="$router.push('/service')">了解更多 +</div>
  </div>
</template>

<script>
  export default {
    name: "service",
    // props: ['currentScreen'],
    data() {
      return {
        serviceItem:[],
        bot_min_fast: {
          transition: "transform .5s,bottom .5s",
          bottom: "-425px"
        },
        bot_min_normal: {
          transition: "transform .5s,bottom 1s",
          bottom: "-425px"
        },
        bot_min_low: {
          transition: "transform .5s,bottom 1.5s",
          bottom: "-425px"
        }
      }
    },
    created() {
      this.$http.get('/api/skills/info/list').then((res)=>{
        this.serviceItem = res.data.rows
      })
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, true);
    },
    methods: {
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
          document.body.scrollTop
        if (scrollTop >= 1500) {
          this.bot_min_fast.bottom = "0px"
          this.bot_min_normal.bottom = "0px"
          this.bot_min_low.bottom = "0px"
        }
      },
    }
  }
</script>

<style scoped>
  .service-container {
    height: 100vh;
  }

  .content {
    text-align: center;
    padding-top: 130px;
  }

  .en-title {
    margin-top: 20px;
    font-size: 16px;
    font-style: italic;
    font-weight: bold;
  }

  .title {
    font-size: 40px;
    /*font-weight: 600;*/
  }

  .our-service {
    display: flex;
    margin: 100px auto 0;
    width: 64%;
    justify-content: space-around;
  }

  .box {
    width: 360px;
    height: 400px;
    border-radius: 20px;
    background-color: #fff;
    box-sizing: border-box;
    transition: padding-top .5s;
    position: relative;
    margin: 0 auto;
  }

  .box:hover {
    transform: scale(1.05);
    box-shadow: 0 5px 20px #e3e3ed;
  }

  .service-logo {
    width: 100%;
    display: flex;
  }

  .service-logo img {
    width: 100%;
    height: 100%;
    margin: 40px auto 20px;
    /*border-radius: 20px;*/
  }

  .service-text {
    width: 100%;
    height: 60px;
    padding-top: 10px;
    text-align: center;
    font-weight: bold;
  }

  .more-product-btn {
    margin: 80px auto 0;
    width: 200px;
    height: 50px;
    border: 1px solid #000;
    line-height: 50px;
    text-align: center;
    transition: all .5s;
    color: #333;
    font-weight: bold;
    cursor: pointer;
  }

  .more-product-btn:hover {
    transform: scale(1.06);
  }

  @media (max-width: 1600px) {
    .our-service {
      width: 75%;
    }
  }

  @media (max-width: 1200px) {
    .our-service {
      width: 90%;
    }
  }

  @media (max-width: 1050px) {
    .our-service {
      width: 100%;
    }
  }

  @media (max-width: 992px) {
    .service-container {
      height: auto;
    }

    .title {
      font-size: 16px;
    }

    .en-title {
      font-size: 12px;
    }

    .our-service {
      flex-direction: column;
    }

    .box {
      margin: 20px auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/section/service.vue